
import keys from './keys'
import constants from './constants'
import patterns from './patterns'
import rules from './rules'
import endpoint from './endpoint'
import urls from './urls'
import routers from './routers'
import menus from './menus'

export default {
  jsCore: null,
  endpoint: endpoint,
  constants: constants,
  routers: routers,
  menus: menus,
  patterns: patterns,
  rules: rules,
  store: null,
  keys: keys,
  urls: urls,
  env: {},
  confirm: () => {},
  notification: () => {},
  navigate: () => {},
  pushSuccess: () => {},
  pushError: () => {},
}